define(function (require) {

    var BaseEngagementWidget = require('web-agent-widgets/BaseEngagementWidget');
    var lpBaseListController = require('web-agent-assets-js/lpBaseListController');

    var partialConversationContext = {};

    var ConnectionsLogEngagementWidget = BaseEngagementWidget.extend({
        ControllerName: "ConnectionsLogEngagementWidget",
        applicationType: "ConnectionsLogEngagementWidget",

        initialize: function (options) {
            this.activeEngagementId = null;
        },
        events: function() {
            this.viewEventsHandler.bindEvent({
                appName: this.tableName,
                UIEvent: this.eventType.TABLE_WIDGETS_CLOSED,
                callback: this.onWidgetClosed
            });
        }
    });

    ConnectionsLogEngagementWidget.prototype.onSelectedEngagementChanged = function (data) {
        BaseEngagementWidget.prototype.onSelectedEngagementChanged.call(this, data);
        var self = this;
        var prevEngagementId = this.activeEngagementId;
        var engagementId = this.widgetsManager.selectedItemId;

        // Remove all listeners for the partial context to remove the complexity of managing prev listener.
        // Only one listener can exist.
        this.modelController.unbindModelParam(null, null, partialConversationContext);

        if(prevEngagementId === engagementId){
            return;
        }

        if (prevEngagementId && prevEngagementId !== engagementId) {
            // Remove the Binding for the Partial conversation if has any.
            this.modelController.unbindModelParam(this.modelController.getModelPaths().metadata + '.' + prevEngagementId, handlePartialConversationChange);
        }

        if (this.activeEngagementId !== engagementId) {
            // Setting the Selected Item to the current controller.
            this.modelController.setSelectedItem(engagementId); // This should be elsewhere, on the table abstraction layer.
            this.engagementVC.updateChatId(engagementId);
            // Setting the Active Engagement Id.
            this.activeEngagementId = this.widgetsManager.selectedItemId;

            handlePartialConversations(engagementId);
        }

        function handlePartialConversations(engagementId) {
            var engagementMetaDataPath = self.modelController.getModelPaths().metadata + '.' + engagementId;
            var engagementMetaDataStatePath = engagementMetaDataPath + '.state';
            var metaData = self.modelController.getModelParam(engagementMetaDataPath);
            if (metaData.isPartial) {
                self.modelController.bindModelParam(engagementMetaDataStatePath, handlePartialConversationChange, partialConversationContext);
            }
        }

        function handlePartialConversationChange(data) {
            // Async Lock for the request.
            if (self.activeEngagementId === engagementId) {
                if (data.newValue === lpBaseListController.STATES.FETCHING) {
                    self.engagementVC.setLoading();
                }
                else {
                    // Done fetching. if error, show partial data. (UX?)
                    self.engagementVC.updateChatId(engagementId);
                    self.engagementVC.removeLoading();
                    self.modelController.unbindModelParam(null, null, partialConversationContext);
                }
            }
        }
    };

    ConnectionsLogEngagementWidget.prototype.onSelectedEngagementRemoved = function () {
        this.activeEngagementId = null;
    };

    ConnectionsLogEngagementWidget.prototype.onWidgetClosed = function () {
        if(lpTag.WebAgent.audioController) {
            lpTag.WebAgent.audioController.end();
        }
    };



    return ConnectionsLogEngagementWidget;

});
